import { useState } from 'react';
import styles from './license-plate-list.module.sass';
import { vehicleTypes } from 'config/vehicle';
import TextBlurButton from 'componets/text-blur-button';
import { CheckCircleFillIcon, TimeFillIcon, ErrorCircleFillIcon, InvoiceIcon } from 'icons';
import { LicensePlateControllerCard } from '../license-plate-controller-card';
import analytics from 'service/analytics';

export const LicensePlateListItem = ({
  licensePlateId,
  plateNumber,
  vehicleType,
  energySource,
  oilType,
  isMochipassEnable,
  isAutoSyncLicensePlateMochipass,
  taipeiParkingBindingStatus: _taipeiParkingBindingStatus,
  taxSetting,
  hasUserAgreedTermsOfTaipeiParkingService,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const vehicleTypeLabel = vehicleTypes.find(({ id }) => id === vehicleType)?.value;

  const taipeiParkingUIState = getLicensePlateTaipeiParkingStatus({
    taipeiParkingBindingStatus: _taipeiParkingBindingStatus,
    hasUserAgreedTermsOfTaipeiParkingService,
  });

  const refuelingBindingStatus = getLicensePlateRefuelingStatus({
    isAutoSyncLicensePlateMochipass,
    isMochipassEnable,
    energySource,
  });

  const checkIcon = <CheckCircleFillIcon width={16} height={16} color="#00D7B2" />;
  const timeIcon = <TimeFillIcon width={16} height={16} color="#CCCCCC" />;
  const errorIcon = <ErrorCircleFillIcon width={16} height={16} color="#F65555" />;
  const invoiceIcon = <InvoiceIcon width={16} height={16} />;

  let parkingStatus = null;
  let refuelingStatus = null;
  let bothBoundStatus = null;

  switch (taipeiParkingUIState) {
    case 'bound':
      parkingStatus = <StatusItem icon={checkIcon} content="停車" />;
      break;
    case 'processing':
      parkingStatus = <StatusItem icon={timeIcon} content="停車綁定中" />;
      break;
    case 'binding_failed':
      parkingStatus = <StatusItem icon={errorIcon} content="停車綁定失敗" />;
      break;
    default:
      parkingStatus = null;
      break;
  }

  switch (refuelingBindingStatus) {
    case 'bound':
      refuelingStatus = <StatusItem icon={checkIcon} content="加油" />;
      break;
    case 'processing':
      refuelingStatus = <StatusItem icon={timeIcon} content="加油綁定中" />;
      break;
    case 'binding_failed':
      refuelingStatus = <StatusItem icon={errorIcon} content="加油綁定失敗" />;
      break;
    default:
      refuelingStatus = null;
      break;
  }

  if (taipeiParkingUIState === 'bound' && refuelingBindingStatus === 'bound') {
    bothBoundStatus = <StatusItem icon={checkIcon} content="加油・停車" />;
  }

  if (isEditing) {
    return (
      <LicensePlateControllerCard
        oilType={oilType}
        energySource={energySource}
        vehicleType={vehicleType}
        taxSetting={taxSetting}
        licensePlateId={licensePlateId}
        plateNumber={plateNumber}
        onClose={() => setIsEditing(false)}
      />
    );
  }

  return (
    <li className={styles['item']}>
      <div className={styles['item__left-section']}>
        <div className={styles['item__left-section__plate-info']}>
          <span className={styles['license-plate__vehicle-info']}>{vehicleTypeLabel}</span>
          <span style={{ marginLeft: '12px' }}>{plateNumber}</span>
        </div>
        <div className={styles['item__left-section__status-info']}>
          {bothBoundStatus == null ? (
            <>
              {refuelingStatus}
              {parkingStatus}
            </>
          ) : (
            bothBoundStatus
          )}
          {refuelingStatus != null && parkingStatus != null && (
            <span style={{ background: '#EEEEEE', width: '1px', height: '16px', marginRight: '8px' }} />
          )}
          <span className={styles['item__left-section__status-item']}>
            {invoiceIcon}
            {taxSetting?.taxIdNumber}
          </span>
        </div>
      </div>
      <div style={{ marginLeft: '16px', whiteSpace: 'nowrap' }}>
        <TextBlurButton
          onClick={() => {
            analytics.licensePlatesEditPlateButtonClick({ plateNumber });
            setIsEditing(true);
          }}
        >
          修改
        </TextBlurButton>
      </div>
    </li>
  );
};

const StatusItem = ({ icon, content }) => {
  return (
    <span className={styles['item__left-section__status-item']}>
      {icon}
      {content}
    </span>
  );
};

function getLicensePlateTaipeiParkingStatus({ taipeiParkingBindingStatus, hasUserAgreedTermsOfTaipeiParkingService }) {
  if (!hasUserAgreedTermsOfTaipeiParkingService) return 'none';

  return taipeiParkingBindingStatus;
}

function getLicensePlateRefuelingStatus({ isAutoSyncLicensePlateMochipass, isMochipassEnable, energySource }) {
  if (energySource === 'electric') return 'bound';
  if (isAutoSyncLicensePlateMochipass && isMochipassEnable) return 'bound';
  if (isAutoSyncLicensePlateMochipass) return 'processing';
  return 'none';
}
